module.exports = __webpack_public_path__ + "img/9788954428187.82a57218.jpg";